export function TotalExpenditureIcon() {
  return (
    <svg
      version="1.1"
      width="26"
      height="26"
      viewBox="0 0 64 64"
    >
      <g>
        {/* Credit Card Shape */}
        <rect
          x="8"
          y="18"
          width="48"
          height="28"
          rx="4"
          ry="4"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
        />
        {/* Card Stripe */}
        <line
          x1="8"
          y1="26"
          x2="56"
          y2="26"
          stroke="currentColor"
          strokeWidth="2"
        />
        {/* Minus Symbol for Expenditure */}
        <line
          x1="24"
          y1="40"
          x2="40"
          y2="40"
          stroke="currentColor"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}
